module.exports = __webpack_public_path__ + "media/force2.57603d00.webm";